/* eslint-disable react/react-in-jsx-scope */
import PropTypes from 'prop-types'
import * as Sc from './Text.style'
import { TYPES_TAGS } from './constants/tags'

const Text = ({ children, type }) => {
  if (type === TYPES_TAGS.SPAN) {
    return <Sc.Span role='presentation'>{children}</Sc.Span>
  }
  return <Sc.Paragraph role='paragraph'>{children}</Sc.Paragraph>
}

Text.defaultProps = { type: '' }

Text.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
}

export default Text
